import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap';
import firebase from "../../firebase/firebase-config";
import { updateToken } from '../../authPages/BaseRequester';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

const BankCard = ({ data }) => {

    const [user, setuser] = useState({})
    const [date, setdate] = useState('')


    const get_user = () => {
        const user = firebase.firestore().collection('users').doc(data.id).onSnapshot((user) => {

            setuser(user.data());


        })



        // const date = new Date(data.date.seconds * 1000 + data.date.nanoseconds / 1000000);
        // setdate(date.toString());

    }

    useEffect(() => {
        get_user();
    }, [])



    return (




        <Col md="4" key={1}>
            <Card className="card-user shadow-lg">
                <CardBody>
                    <CardText />
                    <div className="d-flex justify-content-between  " >
                        <div className=" d-flex ">
                            <img
                                alt="..."
                                className="avatar_single_user"
                                src={user?.profilePicture}
                            />
                            {/* <div>{user?.isOnline == false ? <div className="px-4 d-flex justify-content-center align-items-center  font-weight-bolder" style={{ backgroundColor: '#DD011B', borderRadius: '20px' }}> <p className='font-weight-bold'>Ofline</p>    </div> : <div className="px-4 d-flex justify-content-center align-items-center " style={{ backgroundColor: '#30DF1E', borderRadius: '20px' }}> <p className="font-weight-bold">Online</p>    </div>}
                                </div> */}
                            <div className="ml-2 mt-2">
                                <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{user?.username}</p>
                                <p className="description" style={{ fontSize: '12px' }}>{user.fullName}</p>

                            </div>

                        </div>
                        <p className="description" style={{ fontSize: '14px' }}>Beyown user</p>


                    </div>



                    <div>
                        <div className="d-flex" style={{ color: 'white' }}>
                            Current Status : {data?.verificationStatus == 'Pending' ? <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(90deg, rgba(0,159,253,1) 0%, rgba(42,42,114,1) 100%)', borderRadius: '8px' }}>Pending</p> : data?.verificationStatus == 'verified' ? <p className="font-weight-bold px-3 ml-2" style={{ background: ' linear-gradient(to right, #04FF00, #00FFAE)', borderRadius: '8px' }}>Verified</p> : data?.verificationStatus == 'InProgress' ? <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(to right, #FEE823, #9E9333)', borderRadius: '8px' }}>In Progress</p> : <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(to right, #606c88, #3f4c6b)', borderRadius: '8px' }}>Declined</p>}
                        </div>


                        <h5 className="description">Verification Status For: {user?.fullName} - @{user?.username}</h5>
                        <h5 className="description">Account Name: {data.name}</h5>
                        <h5 className="description">Account Number: {data.accountNumber} </h5>

                        {/* <h5 className="description">Date: {date}</h5> */}

                    </div>




                </CardBody>
                <CardFooter>
                    <div className="button-container d-flex justify-content-around align-items-center">
                        {/* <Link to={`/admin/Total-Orders/Single-Order`}>

                            <div className="btn btn-round" color="facebook">
                                See All Details
                            </div>
                        </Link> */}
                        {
                            data.verificationStatus == 'Pending' ? <div className='d-flex justify-content-between '>

                                <Button onClick={async (e) => {
                                    e.preventDefault();
                                    const type = 'verified'

                                    firebase.firestore().collection('bankDetails').doc(data?.id).update({
                                        'verificationStatus': type
                                    });
                                    var token = await updateToken();
                                    const header = `Authorization: Bearer ${token}`;
                                    const config = {
                                        headers: { "Authorization": `Bearer ${token}` }
                                    }
                                    const uuid =
                                        uuidv4();
                                    var NotificaitonData = {
                                        id: uuid,
                                        title: `Beyown Bank Account Status`,
                                        message: `Yahooo! Your Account Details For Beyown is updated to ${type}, Tap to view more...`,
                                        icon: "",
                                        topics: "",
                                        data: {},
                                        type: "follow",
                                        // senderId: "",
                                        userId: data?.id,
                                    }
                                    axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/sendNotification', NotificaitonData, config)

                                    // firebase.firestore().collection('users').doc(data?.id).update({
                                    //     'visaIdVerificationState': 'verified'
                                    // })
                                }}>


                                    Verify

                                </Button>
                                <Button onClick={async (e) => {
                                    e.preventDefault();
                                    const type = 'declined'
                                    firebase.firestore().collection('bankDetails').doc(data?.id).update({
                                        'verificationStatus': type
                                    })
                                    var token = await updateToken();
                                    const header = `Authorization: Bearer ${token}`;
                                    const config = {
                                        headers: { "Authorization": `Bearer ${token}` }
                                    }
                                    const uuid =
                                        uuidv4();
                                    var NotificaitonData = {
                                        id: uuid,
                                        title: `Beyown Bank Account Status`,
                                        message: `Sorry! Your Account Details For Beyown is updated to ${type}, Tap to view more...`,
                                        icon: "",
                                        topics: "",
                                        data: {},
                                        type: "follow",
                                        // senderId: "",
                                        userId: data?.id,
                                    }
                                    axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/sendNotification', NotificaitonData, config)

                                    // firebase.firestore().collection('users').doc(data?.id).update({
                                    //     'visaIdVerificationState': 'verified'
                                    // })
                                }}>


                                    decline

                                </Button>
                            </div>


                                : ""
                        }
                        {data.verificationStatus == 'verified' ? <Button onClick={async (e) => {
                            e.preventDefault();
                            const type = 'declined'
                            firebase.firestore().collection('bankDetails').doc(data?.id).update({
                                'verificationStatus': type
                            })
                            var token = await updateToken();
                            const header = `Authorization: Bearer ${token}`;
                            const config = {
                                headers: { "Authorization": `Bearer ${token}` }
                            }
                            const uuid =
                                uuidv4();
                            var NotificaitonData = {
                                id: uuid,
                                title: `Beyown Bank Account Status`,
                                message: `Sorry! Your Account Details For Beyown is updated to ${type}, Tap to view more...`,
                                icon: "",
                                topics: "",
                                data: {},
                                type: "follow",
                                // senderId: "",
                                userId: data?.id,
                            }
                            axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/sendNotification', NotificaitonData, config)

                            // firebase.firestore().collection('users').doc(data?.id).update({
                            //     'visaIdVerificationState': 'verified'
                            // })
                        }}>


                            decline

                        </Button> : ""}
                        {data.verificationStatus == 'declined' ? <Button onClick={async (e) => {
                            e.preventDefault();
                            const type = 'verified'
                            firebase.firestore().collection('bankDetails').doc(data?.id).update({
                                'verificationStatus': type
                            })
                            var token = await updateToken();
                            const header = `Authorization: Bearer ${token}`;
                            const config = {
                                headers: { "Authorization": `Bearer ${token}` }
                            }
                            const uuid =
                                uuidv4();
                            var NotificaitonData = {
                                id: uuid,
                                title: `Beyown Bank Account Status`,
                                message: `Yahoo! Your Account Details For Beyown is updated to ${type}, Tap to view more...`,
                                icon: "",
                                topics: "",
                                data: {},
                                type: "follow",
                                // senderId: "",
                                userId: data?.id,
                            }
                            axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/sendNotification', NotificaitonData, config)

                            // firebase.firestore().collection('users').doc(data?.id).update({
                            //     'visaIdVerificationState': 'verified'
                            // })
                        }}>


                            verify

                        </Button> : ""}






                    </div>

                </CardFooter>
            </Card>

        </Col >

    );

}

export default BankCard